<div id="filter-dialog-container" class="info-box">
  <div mat-dialog-title class="filter-title">
    <h1 class="info-box-heading">Filter Correspondence</h1>
  </div>
  <div class="info-box-wrapper">
    <mat-dialog-content class="info-box-body">
      <!-- date -->
      <div class="flex-row-center-center">
        <h2>Date</h2>
        <mat-button-toggle-group [formControl]="sortControl">
          <mat-button-toggle value="true" class="toggle-left-btn"
            ><mat-icon>arrow_upward</mat-icon></mat-button-toggle
          >
          <mat-button-toggle value="false"
            ><mat-icon>arrow_downward</mat-icon></mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>
      <!-- communication type -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Communication Type"
            [matAutocomplete]="commTypeAuto"
            [formControl]="commTypeControl" />
        </mat-form-field>
        <mat-autocomplete #commTypeAuto="matAutocomplete">
          @for (type of filteredCommTypes | async; track type) {
          <mat-option [value]="type"> {{ type }} </mat-option>
          }
        </mat-autocomplete>
      </div>
      <!-- category -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Category"
            [matAutocomplete]="categoryAuto"
            [formControl]="categoryControl" />
        </mat-form-field>
        <mat-autocomplete #categoryAuto="matAutocomplete">
          @for (cat of filteredCategories | async; track cat) {
          <mat-option [value]="cat"> {{ cat }} </mat-option>
          }
        </mat-autocomplete>
      </div>
      <!-- contact -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Contact"
            [matAutocomplete]="requestorAuto"
            [formControl]="requestorControl" />
        </mat-form-field>
        <mat-autocomplete #requestorAuto="matAutocomplete">
          @for (req of filteredRequestors | async; track req) {
          <mat-option [value]="req.FullName"> {{ req.FullName }} </mat-option>
          }
        </mat-autocomplete>
      </div>
      <!-- reviewer -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Reviewer"
            [matAutocomplete]="reviewerAuto"
            [formControl]="reviewerControl" />
        </mat-form-field>
        <mat-autocomplete #reviewerAuto="matAutocomplete">
          @for (rev of filteredReviewers | async; track rev) {
          <mat-option [value]="rev.FullName"> {{ rev.FullName }} </mat-option>
          }
        </mat-autocomplete>
      </div>
      <!-- status -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Status"
            [matAutocomplete]="statusAuto"
            [formControl]="statusControl" />
        </mat-form-field>
        <mat-autocomplete #statusAuto="matAutocomplete">
          @for (status of filteredStatuses; track status) {
          <mat-option [value]="status"> {{ status }} </mat-option>
          }
        </mat-autocomplete>
      </div>
      <!-- keyword -->
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            placeholder="Keywords"
            [formControl]="keywordsControl" />
        </mat-form-field>
      </div>
      <!-- save filter -->
      <div class="filter-container flex-column">
        <mat-checkbox
          [formControl]="saveToFavorites"
          class="saveToFavs"
          >Save to Favorites</mat-checkbox
        >
        <mat-form-field appearance="outline">
          <input
            matInput
            [attr.disabled]="!saveToFavorites.value ? '' : null"
            placeholder="Filter Name"
            [formControl]="filterName" />
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="info-box-btn flex-row-end">
      <button class="btn-save" mat-raised-button (click)="saveAndClose()">
        Apply
      </button>
      <button mat-raised-button (click)="close()">Cancel</button>
    </mat-dialog-actions>
  </div>
</div>
